import { render, staticRenderFns } from "./CardsLoader.vue?vue&type=template&id=156ffdc6&scoped=true"
import script from "./CardsLoader.vue?vue&type=script&lang=js"
export * from "./CardsLoader.vue?vue&type=script&lang=js"
import style0 from "./CardsLoader.vue?vue&type=style&index=0&id=156ffdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ffdc6",
  null
  
)

export default component.exports